import e from"./ClearRefinements.vue_vue&type=script&lang.js";import{render as t}from"./ClearRefinements.vue_vue&type=template&id=1b5799b9&lang.js";e.render=t;export default e;
//# sourceMappingURL=ClearRefinements.vue.js.map
